import { GeoJSON } from 'ol/format'

const VectorQuery = map => {
  const geoJsonFormat = new GeoJSON()
  const writeGeoJsonFeature = geoJsonFormat.writeFeatureObject.bind(
    geoJsonFormat
  )

  const query = (layer, queryOptions) => {
    const features = map.getFeaturesAtPixel(queryOptions.pixel, {
      hitTolerance: queryOptions.padding,
      layerFilter: l => l.get('name') === layer.name
    })
    const geoJSON = {
      type: 'FeatureCollection',
      features: features ? features.map(writeGeoJsonFeature) : []
    }

    return Promise.resolve(geoJSON)
  }

  const isLayerSupported = layer => layer.type === 'Vector'

  return {
    query,
    isLayerSupported
  }
}

export default VectorQuery
